module.exports = {
  siteTitle: 'Nourelhouda Naimi', // <title>
  manifestName: 'Resume',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/light_icon.jpg',
  pathPrefix: `/gatsby-starter-resume/`, // This path is subpath of your hosting https://domain/portfolio
  firstName: 'Nourelhouda',
  lastName: 'Naimi',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/NaimiNour',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://linkedin.com/in/nourelhouda-naimi-361894125/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/@NaimiNourelhou1',
    },
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://www.facebook.com/nourelhouda.naimi.52/',
    },

  ],
  email: 'naimi.nour16@gmail.com',
  phone: '0657938660',
  address: '05 Road Bougtob, Elbayadh, 32000',
};
